'use es6';

import * as ActionTypes from './ActionTypes';
import * as ecosystemClient from '../clients/ecosystemClient';
export const getUnusedFilters = () => dispatch => {
  dispatch({
    type: ActionTypes.STOREFRONT_UNUSED_FILTERS_REQUESTED
  });
  ecosystemClient.getUnusedFilters().then(resp => {
    dispatch({
      type: ActionTypes.STOREFRONT_UNUSED_FILTERS_RECEIVED,
      payload: resp
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.STOREFRONT_UNUSED_FILTERS_FAILED,
      payload: error
    });
  });
};
export const updateResultsView = value => dispatch => {
  dispatch({
    type: ActionTypes.STOREFRONT_RESULTS_VIEW_UPDATED,
    payload: value
  });
};